import React, { useCallback } from 'react';
import { RoutedComponentProps } from 'src/app-routes';
import { generatePath } from 'react-router';
import { ILexiconTagsPaginationAPI } from 'src/services';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { LexiconRuleModal } from 'src/components-bl/Lexicon/components/LexiconRules/LexiconRuleModal';
import { LexiconTagType } from 'src/services/src/service/lexicon/types';
import { useValidateLocale } from '../../hooks';
import { createLexiconRuleContainerActions } from './CreateLexiconRuleContainer.actions';

export type CreateLexiconRuleContainerProps = RoutedComponentProps & {
  refetchLexiconTags?: () => Promise<ILexiconTagsPaginationAPI>;
};

export const CreateLexiconRuleContainer = ({
  permittedRouteMap,
  refetchLexiconTags,
}: CreateLexiconRuleContainerProps): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const shopId = useAppSelector(state => state.shop.current?.shopId);

  const locale = useValidateLocale({ permittedRouteMap, dispatch, shopId })?.locale;

  const onModalClose = useCallback(() => {
    if (permittedRouteMap.lexiconCategories?.path && shopId && locale) {
      dispatch(
        createLexiconRuleContainerActions.navigateTo({
          navigateTo: generatePath(permittedRouteMap.lexiconCategories.path, {
            shopId,
            locale,
            tagType: LexiconTagType.RenameRules,
          }),
        })
      );
    }
  }, [dispatch, permittedRouteMap.lexiconCategories, locale, shopId]);

  const onSuccess = useCallback(() => {
    refetchLexiconTags?.();
  }, [refetchLexiconTags]);

  if (!shopId || !locale) {
    return null;
  }

  return shopId ? (
    <LexiconRuleModal
      dispatch={dispatch}
      mode='create'
      onClose={onModalClose}
      onSuccess={onSuccess}
      shopId={shopId}
      locale={locale}
      lexiconRule={undefined}
    />
  ) : null;
};
